const endpoints = {
  loginWithEmail: "/auth/username-login/validate",
  loginOrRegister: "/auth/social-login/validate",
  refreshAccessToken: "/auth/token/refresh",
  sidebar: "brand/configs/navigations",
  brandCategories: "brand/profile/brand_categories",
  getEmail: "business/profile/user/email",
  // brand : '/brand/profile',
  imageUpload: "/image/upload",
  brand: "brand/profile",
  createPassword: "/username-password/set",
  resetPassword: "/username-password/reset ",

  refreshAccessToken: "/auth/token/refresh",

  //Super Adimin Post request urls
  createPostAdmin: "/super-admin/content/post_create",
  createPoll_Admin: "/super-admin/content/poll_create",
  createContent__videoUpload_Admin: "super-admin/content/krishi_clip_create",
  createContent__updateOrDelete_Admin: "/super-admin/content/",
  createContent__createForm_admin: "super-admin/form/create",
  createContent__form_admin: "super-admin/form/",
  // CREATE CONTENT MODULE
  // createPost: "/super-admin/content/post_create",
  createPost: "/brand/content/post_create",
  createPoll: "/brand/content/poll_create",
  publishPoll: "/brand/content/{id}/poll_update",
  content: "/brand/content/all",
  createContent__updateOrDelete: "/brand/content/",
  createContent__getImageOrVideoConfigs: "/brand/content/configs",
  createContent__getPresignedURLs:
    "/aws/configurations/presigned_url/multiple-uploads",
  createContent__getVideoPresignedURLs:
    "/aws/configurations/pre-signed/multiparts",
  createContent__uploadComplete:
    "/aws/configurations/pre-signed/complete_multipart_uploads",
  createContent__registerVideo: "video/register",
  createContent__videoUpload: "brand/content/krishi_clip_create",
  createContent__abortVideoUpload:
    "/aws/configurations/pre-signed/abort_multipart_uploads",
  createContent__postDetails: "brand/content/details",
  createContent__form: "/form/",
  createContent__formConfigs: "/form/configs",
  createContent__createForm: "form/create",
  createContent_leadFormList: "form/list",
  createContent__attachForm: "agg-feed/post/attach_form",
  createContent__detachForm: "agg-feed/post/detach_form",
  createContent__comment: "/feed_activity/comment",
  createContent__nestedComment: "/feed_activity/nested/comment",

  //hashtags
  hashtag_service: "/service/app-search/api/v1/results/hashtag",

  // ACTIVE LEADS
  activeLeads__list: "form/responses",
  activeLeads__downloadLeads: "/form/download/responses",
  activeleads__formDetails: "/form/detail",

  // PRODUCTS
  products__list: "/business-web/product/list",
  products__categories: "/product/categories",
  products__addProductConfigs: "/business/inventory/create/config",
  products__brandList: "/product/brands",
  products__historicalProducts: "/business/inventory",
  products__masterProducts: "/product/product",
  products__measuringUnits: "/product/measuring_unit",

  //Orders Razoray
  order_getDetails: "/ecommerce-order",
  order_verify: "/ecommerce-order/verify/purchase-amount",
  order_payment_initiate: "/ecommerce-order/payment-initiate",
  order_payment_confirmation: "/ecommerce-order/payment-confirmation",

  //Review
  get_review: "/brand/profile/users/review",

  //Dashboard
  getDefaultDashboard: "business/default",
  dashboard_pageView: "business/pageView",
  dashboard_avergaerating: "business/user_ratings",
  dashboard_demographic: "business/demographics",
  dashboard_uniqueVisitors: "business/unique_visitors",
  dashboard_followers: "business/followers",

  //Discover
  getUser_search: "business/user_search",
  getStates: "addresses/states",
  getEntityResult: "/service/app-search/api/v1/results/entity-results",
  getWordCloudTopic: "/broadcast/topic/",
  getWordCloudCrop: "/broadcast/crop/",
  getTopqueries: "business/user_post_queries/",
  getUser_LatLng: "business/user_search_term/",
  getCropStage: "business/crop_stage_query/",
  getCropDisease: "business/crop_disease_query/",

  //My farmer
  myfarmer_followers: "business/dashboard/followers",
  myfarmer__getPresignedURLs: "/aws/configurations/presigned_url",
  broadcast_types: "/broadcast/choices",
  getuser_product: "/ecommerce-order/user/products",
  intent_capture: "/broadcast/intent_capture/",
  state_ids: "/addresses/states",
  broadcast_choice: "/broadcast/choices",
  followers_location: "/business/get_follower_location_data/",

  //Map
  getUserDetails_map: "/business/user_detail/",

  //query
  getTagHierarchy: "/business/tags/hierarchy",
  getUserQueries: "/business/user_queries",
  getCroplist: "/crop-info/crop",
  getStatesQuery: "/addresses/states",
  getClipedQuerylist: "/business/query-clipboard/list",
  deleteClipedQuery: "/business/query-clipboard",
  addClipedQuery: "/business/query-clipboard/save",
  getRespondedQuery: "/business/comments/list",
  postbulkComment: "/feed_activity/bulk-comment",

  // super admin | Business list
  getbusinesslist: "/super-admin/business-profile/list",
  updateBusinessProfile: "/super-admin/business-profile/update",
  getConfigs: "/super-admin/configs",
  getDistricst: "/addresses/districts",
  getTopics: "/topics",
  createCampaign: "/super-admin/create",
  getCampaignList: "/super-admin/campaign/list",
  getCamapignDetails: "/super-admin/campaign/detail",
  getCTAlist: "/super-admin/cta_configs",
  pauseCampaign: "/super-admin/campaign_resume_pause",
  editCampaign: "/super-admin/edit",

  //Deeplink
  deeplink: "deep-link",
  //Landing Page Demo
  requestDemo: "/business/profile/demo-session/create",

  //crm
  user_list: "/crm/users/all/",
  user_details: "/crm/user/details",
  interests: "/crm/interests",
  crops:'/crm/crops',
  brands:'/crm/brands',
  user_crop_detials:'crm/crop_disease',
  user_brand_details:'crm/user/brands',
  tractors:'crm/tractors',
  animals:'/crm/animals',

};

export default endpoints;
